export const BUILD_NUMBER = 'e421cd'; export const SEQUENTIAL_BUILD_NUMBER = '1457'; export const PACKAGE_VERSION = '3.4.2';export const SELECTED_THEME = 'smartcr';
